let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cAtsg")).then(() => parcelRequire('8azmD'));